// SelectionContext.js
import { createContext } from 'react';

// Create the context
export const SelectionContext = createContext();